<div
  class="dropdown-container"
  data-cy="mojo-dropdown-container"
  #dropdownContainer
>
  <div
    *ngIf="active"
    #dropdown
    data-cy="mojo-dropdown-content"
    class="dropdown"
    [ngClass]="{'mobile-full-width': fullWidthOnMobile}"
  >
    <ng-content></ng-content>
  </div>
</div>
